import React, { Component } from "react";

import {
  Table,
  Card,
  Row,
  Col,
  Form,
  Image,
  Button,
  Tabs,
  Nav,
  Tab
} from "react-bootstrap";
import "./EditProfile.css";
import { BrowserRouter as Router, Route, Link } from "react-router-dom";
import { appConfig } from "../../config";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from "react-places-autocomplete";
import "../Common/Common.css";
import TimePicker from "react-time-picker";
import { fetchDistributorProfile } from "../../containers/MyProfileContainer/action";
import { EditDistributorprof } from "../../containers/MyProfileContainer/action";
import { fetchStates } from "../../containers/MyProfileContainer/action";
import { fetchDistrictById } from "../../containers/MyProfileContainer/action";
import { fetchBank } from "../../containers/MyProfileContainer/action";
import { connect } from "react-redux";
var dateFormat = require("dateformat");


class EditProfile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      amal: "amal",
      selectSegData: null,
      location: this.props.DistributorprofDtls
        ? this.props.DistributorprofDtls.addr1
        : null,
      lat: "",
      longi: "",

      value: {
        name: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.name
          : null,
        contactPersn: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.contactPersn
          : null,
        mobile: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.mobile
          : null,
        email: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.email
          : null,
        addr1: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.addr1
          : null,
        geo: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.geo
          : null,
        addr2: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.addr2
          : null,
        city: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.city
          : null,
        landmark: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.landmark
          : null,
        zip: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.zip
          : null,
        website: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.website
          : null,
        licenceNo: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.licenceNo
          : null,
        licenceNo2: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.drugLicense
          : null,
        gstin: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.gstin
          : null,
        imgUrl: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.imgUrl
          : null,

        acntName: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.acntName
          : null,
        acntNo: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.acntNo
          : null,
        ifscCode: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.ifscCode
          : null,
        brchName: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.brchName
          : null,
        brchAddr: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.brchAddr
          : null,
        acntType: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.acntType
          : null,
        bankName:
          this.props.DistributorprofDtls &&
            this.props.DistributorprofDtls.bankName
            ? this.props.DistributorprofDtls.bankName.id
            : null,

        state: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.state.id
          : null,

        district: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.district.id
          : null,
        crdtPeriod: this.props.DistributorprofDtls
          ? this.props.DistributorprofDtls.crdtPeriod
          : null,
        workingHrs: {
          mon: {
            isWorking: (this.props.DistributorprofDtls && this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.mon.open) ? true : false,
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.mon.open ? this.props.DistributorprofDtls.workingHrs.mon.open : null,
            open: "09:00",
            close: "18:00",
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.mon.close ? this.props.DistributorprofDtls.workingHrs.mon.close : null,
            showDay: "Monday"
          },
          tue: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.tue.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.tue.open ? this.props.DistributorprofDtls.workingHrs.tue.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.tue.close ? this.props.DistributorprofDtls.workingHrs.tue.close : null,
            showDay: "Tuesday"
          },
          wed: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.wed.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.wed.open ? this.props.DistributorprofDtls.workingHrs.wed.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.wed.close ? this.props.DistributorprofDtls.workingHrs.wed.close : null,
            showDay: "Wednesday"
          },
          thu: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.thu.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.thu.open ? this.props.DistributorprofDtls.workingHrs.thu.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.thu.close ? this.props.DistributorprofDtls.workingHrs.thu.close : null,
            showDay: "Thursday"
          },
          fri: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.fri.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.fri.open ? this.props.DistributorprofDtls.workingHrs.fri.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.fri.close ? this.props.DistributorprofDtls.workingHrs.fri.close : null,
            showDay: "Friday"
          },
          sat: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sat.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sat.open ? this.props.DistributorprofDtls.workingHrs.sat.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sat.close ? this.props.DistributorprofDtls.workingHrs.sat.close : null,
            showDay: "Saturday"
          },
          sun: {
            isWorking: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sun.open ? true : false,
            open: "09:00",
            close: "18:00",
            openmin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sun.open ? this.props.DistributorprofDtls.workingHrs.sun.open : null,
            closemin: this.props.DistributorprofDtls && this.props.DistributorprofDtls.workingHrs && this.props.DistributorprofDtls.workingHrs.sun.close ? this.props.DistributorprofDtls.workingHrs.sun.close : null,
            showDay: "Sunday"
          }
        },
        duplicateworkingHrs: {
          mon: {},
          tue: {},
          wed: {},
          thu: {},
          fri: {},
          sat: {},
          sun: {}
        },
      },


      // isStatechanged: false
    };
    this.selectState = this.selectState.bind(this);
    this.selectDistrict = this.selectDistrict.bind(this);
  }

  convertTime = (timefetched) => {
    let hours = Math.floor(timefetched / 60);
    //let AmOrPm = hours >= 12 ? 'pm' : 'am';
    let minutes = timefetched - (hours * 60);
    minutes = (minutes > 10 ? minutes : "0" + minutes);
    let finalTime;
    return finalTime = hours + ":" + minutes;
  }

  oncheckChange = (e, day) => {
    let isChecked = e.target.checked;

    this.setState(
      prevState => ({
        value: {
          ...prevState.value,
          workingHrs: {
            ...prevState.value.workingHrs,
            [day]: {
              ...prevState.value.workingHrs[day],
              isWorking: isChecked,
            }
          }
        }
      }),
    );
  };

  ontimeChange = (val, day, status, inMinutes) => {
    //For conversion to minutes
    let hours = val.substring(0, 2);
    let min = val.substring(3, 5);
    let timeinMinutes = +(hours * 60) + +min; //Using unary plus operators to avoid concatenation;

    this.setState(
      prevState => ({
        value: {
          ...prevState.value,
          workingHrs: {
            ...prevState.value.workingHrs,
            [day]: {
              ...prevState.value.workingHrs[day],
              [status]: val,
              [inMinutes]: timeinMinutes
            }
          },
        }
      }),
    );
  };
  validate = () => {
    // const { state, district } = this.state;

    let isError = false;
    let emailregex = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
    let regex = /[a-z]|[a-z]\s/i;
    let mobreg = (/^[0-9]{10}$/);
    let gstregex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/;
    let zipreg = /^[0-9]{6}$/;

    const errmsg1 = "Enter a valid input";
    const errmsg2 = "This field cannot be empty";
    const errmsg3 = "Please enter a valid email";
    const errmsg4 = "Entered GST is not in valid format";
    const errmsg5 = "Enter a valid pincode";
    const errmsg6 = "Please select a location"

    const errors = {
      nameError: "",
      contactPersnError: "",
      emailError: "",
      mobileError: "",
      locationError: "",
      cityError: "",
      stateError: "",
      districtError: "",
      zipError: "",
      licenceNoError: "",
      licenceNo2Error: "",
      gstError: "",
      acntNameError: "",
      acntTypeError: "",
      brchNameError: "",
      bankNameError: "",
      acntNoError: "",
      ifscCodeError: ""
    };

    if (this.state.value.name === "") {
      isError = true;
      errors.nameError = errmsg2;
    }
    if (this.state.value.contactPersn === "") {
      isError = true;
      errors.contactPersnError = errmsg2;
    }
    if (!emailregex.test(this.state.value.email)) {
      isError = true;
      errors.emailError = errmsg3;
    }
    if (this.state.value.email === "") {
      isError = true;
      errors.emailError = errmsg2;
    }
    if (!mobreg.test(this.state.value.mobile)) {
      isError = true;
      errors.mobileError = errmsg1;
    }

    if (this.state.value.mobile === "") {
      isError = true;
      errors.mobileError = errmsg2;
    }
    if (this.state.value.addr1 === "") {
      isError = true;
      errors.locationError = errmsg2;
    }
    if (this.state.value.city === "") {
      isError = true;
      errors.cityError = errmsg2;
    }
    if (this.state.value.state === "") {
      isError = true;
      errors.stateError = errmsg2;
    }
    if (this.state.value.district === "") {
      isError = true;
      errors.districtError = errmsg2;
    }
    if (this.state.value.zip === "") {
      isError = true;
      errors.zipError = errmsg2;
    }
    if (this.state.value.zip !== "" && !zipreg.test(this.state.value.zip)) {
      isError = true;
      errors.zipError = errmsg5;
    }
    if (this.state.value.licenceNo === "") {
      isError = true;
      errors.licenceNoError = errmsg2;
    }
    if (this.state.value.licenceNo2 === "") {
      isError = true;
      errors.licenceNo2Error = errmsg2;
    }

    if (!gstregex.test(this.state.value.gstin)) {
      isError = true;
      errors.gstError = errmsg4;
    }
    if (this.state.value.gstin === "") {
      isError = true;
      errors.gstError = errmsg2;
    }
    if (this.state.value.acntName === "") {
      isError = true;
      errors.acntNameError = errmsg2;
    }
    if (this.state.value.acntType === "") {
      isError = true;
      errors.acntTypeError = errmsg2;
    }
    if (this.state.value.brchName === "") {
      isError = true;
      errors.brchNameError = errmsg2;
    }
    if (this.state.value.bankName === "") {
      isError = true;
      errors.bankNameError = errmsg2;
    }
    if (this.state.value.acntNo === "") {
      isError = true;
      errors.acntNoError = errmsg2;
    }
    if (this.state.value.ifscCode === "") {
      isError = true;
      errors.ifscCodeError = errmsg2;
    }
    if (this.state.flag === 0) {
      isError = true;
      errors.locationError = errmsg6;
    }
    this.setState({
      ...this.state,
      ...errors
    });

    return isError;
  };

  onChange = event => {
    let name = event.target.name;
    let value = event.target.value;
    if (name == "name") {
      this.setState({
        value: { ...this.state.value, name: value }
      });
    } else if (name == "contactPersn") {
      this.setState({
        value: { ...this.state.value, contactPersn: value }
      });
    } else if (name == "mobile") {
      this.setState({
        value: { ...this.state.value, mobile: value }
      });
    } else if (name == "email") {
      this.setState({
        value: { ...this.state.value, email: value }
      });
    } else if (name == "addr1") {
      this.setState({
        value: { ...this.state.value, addr1: value }
      });
    } else if (name == "city") {
      this.setState({
        value: { ...this.state.value, city: value }
      });
    } else if (name == "landmark") {
      this.setState({
        value: { ...this.state.value, landmark: value }
      });
    } else if (name == "zip") {
      this.setState({
        value: { ...this.state.value, zip: value }
      });
    } else if (name == "website") {
      this.setState({
        value: { ...this.state.value, website: value }
      });
    } else if (name == "licenceNo") {
      this.setState({
        value: { ...this.state.value, licenceNo: value }
      });
    }
    else if (name == "licenceNo2") {
      this.setState({
        value: { ...this.state.value, licenceNo2: value }
      });
    } else if (name == "gstin") {
      this.setState({
        value: { ...this.state.value, gstin: value }
      });
    } else if (name == "addr2") {
      this.setState({
        value: { ...this.state.value, addr2: value }
      });
    } else if (name == "acntName") {
      this.setState({
        value: { ...this.state.value, acntName: value }
      });
    } else if (name == "acntNo") {
      this.setState({
        value: { ...this.state.value, acntNo: value }
      });
    } else if (name == "ifscCode") {
      this.setState({
        value: { ...this.state.value, ifscCode: value }
      });
    } else if (name == "brchName") {
      this.setState({
        value: { ...this.state.value, brchName: value }
      });
    } else if (name == "brchAddr") {
      this.setState({
        value: { ...this.state.value, brchAddr: value }
      });
    } else if (name == "acntType") {
      this.setState({
        value: { ...this.state.value, acntType: value }
      });
    } else if (name == "bankName") {
      this.setState({
        value: { ...this.state.value, bankName: value }
      });
    }
    else if (name == "crdtPeriod") {
      this.setState({
        value: { ...this.state.value, crdtPeriod: value }
      });
    }
  };


  handleSelect = async values => {
    const results = await geocodeByAddress(values);
    const latLng = await getLatLng(results[0]);

    this.setState({
      ...this.state,
      location: values,
      locationError: "",
      flag: 1,//Just to make sure that the user is selecting from the available list of locations. Else lat long cant be fetched
      value: {
        ...this.state.value,
        addr1: results[0].formatted_address,
        geo: [latLng.lng, latLng.lat]
      }
    });
  };

  onLocationChange = values => {
    //console.log(values);
    this.setState({
      ...this.state,
      location: values,
      flag: 0,//Just to make sure that the user is selecting from the available list of locations. Else lat long cant be fetched
      value: {
        ...this.state.value,
        addr1: values
      }
    });
  };

  /* validateFile = filename =>{
    console.log(filename);
    let Errfound = false;

    const errmsg_file = "Only `.png`, `.jpg`, `.jpeg` files accepted";
    const error_file = {
      fileError:"",
    };

    this.getExtension = filename => {
      return filename.name.split(".").pop();
    };

    if((this.getExtension(filename)) !== ("png"||"jpg"||"jpeg")) {
      Errfound = true;
      error_file.fileError = errmsg_file;
    }

    this.setState({
      ...this.state,
      ...error_file
    });

    return Errfound;
  } */

  fileChangedHandler = event => {
    //   console.log(event.target.files[0]);
    const icon = event.target.files[0];

    /*     const validation = this.validateFile(event.target.files[0]);
    
        let prevImgUrl = this.props.DistributorprofDtls? this.props.DistributorprofDtls.imgUrl: null;
     */
    // if (!validation) {
    this.setState({
      value: {
        ...this.state.value,
        fileImg: URL.createObjectURL(event.target.files[0]),
        fileimgvalue: event.target.files[0],
        imgUrl: event.target.files[0]
      }
    });
    /* }else{
      this.setState({
        value: {
          ...this.state.value,
          fileImg: appConfig.imgServerip +"/get?imgName=" +prevImgUrl,
          fileimgvalue:prevImgUrl,
          imgUrl: prevImgUrl
        }
      });
    } */
  };

  editWorkingHrs = async () => {
    await Object.keys(this.state.value.workingHrs).map((item, i) => (
      (this.state.value.workingHrs[item].isWorking) &&
      (
        this.setState(prevState => ({
          value: {
            ...prevState.value,
            duplicateworkingHrs: {
              ...prevState.value.duplicateworkingHrs,
              [item]: {
                ...prevState.value.duplicateworkingHrs[item],
                "open": prevState.value.workingHrs[item].openmin,
                "close": prevState.value.workingHrs[item].closemin,
              }
            }
          }
        }),
          () => { })
      )
    ));
    this.submit();
  };

  submit = () => {
    const value = this.state.value;
    const err = this.validate();

    if (!err) {
      this.setState({ selectSegData: null })
      this.props.EditDistributorprof(this.state.value);
    }
  };


  async componentWillReceiveProps(nextProps) {

    nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.id !== this.state.id && await this.setState({
      amal: 'arun',
      id: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.id,
      value: {
        ...this.state.value,
        name: nextProps.DistributorprofDtls.name,
        contactPersn: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.contactPersn,
        state: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.state.id,
        district: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.district.id,

        mobile:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.mobile,
        email:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.email,
        addr1:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.addr1,
        addr2:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.addr2,
        city:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.city,
        landmark:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.landmark,
        zip:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.zip,
        website:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.website,
        licenceNo:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.licenceNo,
        licenceNo2:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.drugLicense,
        gstin:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.gstin,

        crdtPeriod:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.crdtPeriod,


        imgUrl:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.imgUrl,


        acntName:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.acntName,
        acntNo:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.acntNo,
        ifscCode:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.ifscCode,
        brchName:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.brchName,
        brchAddr:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.brchAddr,
        acntType:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.acntType,
        bankName:
          nextProps.DistributorprofDtls &&
          nextProps.DistributorprofDtls.bankName &&
          nextProps.DistributorprofDtls.bankName.id,

        id:
          nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.id,

        workingHrs: {
          mon: {
            isWorking: (nextProps.DistributorprofDtls && nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.mon.open) ? true : false,
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.mon.open ? nextProps.DistributorprofDtls.workingHrs.mon.open : 540,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.mon.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.mon.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.mon.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.mon.close) : "18:00",
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.mon.close ? nextProps.DistributorprofDtls.workingHrs.mon.close : 1080,
            showDay: "Monday"
          },
          tue: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.tue.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.tue.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.tue.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.tue.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.tue.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.tue.open ? nextProps.DistributorprofDtls.workingHrs.tue.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.tue.close ? nextProps.DistributorprofDtls.workingHrs.tue.close : 1080,
            showDay: "Tuesday"
          },
          wed: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.wed.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.wed.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.wed.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.wed.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.wed.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.wed.open ? nextProps.DistributorprofDtls.workingHrs.wed.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.wed.close ? nextProps.DistributorprofDtls.workingHrs.wed.close : 1080,
            showDay: "Wednesday"
          },
          thu: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.thu.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.thu.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.thu.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.thu.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.thu.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.thu.open ? nextProps.DistributorprofDtls.workingHrs.thu.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.thu.close ? nextProps.DistributorprofDtls.workingHrs.thu.close : 1080,
            showDay: "Thursday"
          },
          fri: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.fri.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.fri.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.fri.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.fri.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.fri.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.fri.open ? nextProps.DistributorprofDtls.workingHrs.fri.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.fri.close ? nextProps.DistributorprofDtls.workingHrs.fri.close : 1080,
            showDay: "Friday"
          },
          sat: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sat.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sat.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.sat.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sat.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.sat.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sat.open ? nextProps.DistributorprofDtls.workingHrs.sat.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sat.close ? nextProps.DistributorprofDtls.workingHrs.sat.close : 1080,
            showDay: "Saturday"
          },
          sun: {
            isWorking: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sun.open ? true : false,
            open: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sun.open ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.sun.open) : "09:00",
            close: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sun.close ? this.convertTime(nextProps.DistributorprofDtls.workingHrs.sun.close) : "18:00",
            openmin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sun.open ? nextProps.DistributorprofDtls.workingHrs.sun.open : 540,
            closemin: nextProps.DistributorprofDtls && nextProps.DistributorprofDtls.workingHrs && nextProps.DistributorprofDtls.workingHrs.sun.close ? nextProps.DistributorprofDtls.workingHrs.sun.close : 1080,
            showDay: "Sunday"
          }
        }

      }
    }, () => {

    });
  }

  selectState(event) {
    this.setState({ selectSegData: "value" });
    this.props.fetchDistrictById(event.target.value);

    this.setState({
      value: {
        ...this.state.value,
        state: event.target.value,
        district: null
      }
    });
  }

  selectDistrict(event) {
    this.setState({
      value: { ...this.state.value, district: event.target.value }
    });
  }

  componentDidMount() {
    this.props.fetchDistributorProfile();
    this.props.fetchStates();
    // this.props.fetchDistrictById();
    this.props.fetchBank();
  }

  onKeyDown(keyEvent) {
    if ((keyEvent.charCode || keyEvent.keyCode) === 13) {
      keyEvent.preventDefault();
    }
  }

  render() {
    if (this.props.districtById === undefined) {
      this.props.fetchDistrictById(this.state.value.state);
    }

    return (
      <div className="salesreturndiv">
        <Row>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
          <Col xs={12} sm={12} md={10} lg={10}>
            <Card>
              <Row>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <div>
                    <h5 className="tablecardtitle edithead">Personal Details </h5>
                  </div>
                </Col>
                <Col xs={12} sm={12} md={6} lg={6}>
                  <div className="editprofclose editclose">
                    <Link to="/myprofile" onClick={() => window.scrollTo(0, 0)}>
                      <i className="fa fa-times fa-lg "></i>
                    </Link>
                  </div>
                </Col>
              </Row>

              <div className="myprofilebody">
                <Card.Body>
                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="contactPersn">
                                <Form.Label>Name</Form.Label>
                                <Form.Control
                                  // type="text"
                                  autoComplete="off"
                                  name="contactPersn"
                                  onChange={this.onChange}
                                  value={this.state.value.contactPersn}
                                />
                                <div className="errStyle">
                                  {this.state.contactPersnError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="email">
                                <Form.Label> Email </Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="email"
                                  onChange={this.onChange}
                                  value={this.state.value.email}
                                />
                                <div className="errStyle">
                                  {this.state.emailError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="mobile">
                                <Form.Label> Mobile Number </Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="mobile"
                                  onChange={this.onChange}
                                  value={this.state.value.mobile}
                                />
                                <div className="errStyle">
                                  {this.state.mobileError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>

                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="addr2">
                                <Form.Label>Address</Form.Label>

                                <Form.Control
                                  as="textarea"
                                  rows="1"
                                  name="addr2"
                                  autoComplete="off"
                                  onChange={this.onChange}
                                  value={this.state.value.addr2}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div className="profileimg">
                        <Form.Group>
                          <div className="fleetEditPrflImg">
                            <div style={{ display: "grid" }}>
                              <Form.Label></Form.Label>
                              <img
                                className="profileeditimage"
                                src={
                                  this.state.value.fileImg
                                    ? this.state.value.fileImg
                                    : appConfig.imgServerip +
                                    "/get?imgName=" +
                                    this.state.value.imgUrl
                                }
                              />
                            </div>
                            <div className="profiledivimgavtr">
                              <div className="file btn btn-lg btn-primary">
                                Change Logo
                                <input
                                  type="file"
                                  name="file"
                                  accept=".png, .jpg, .jpeg"
                                  onChange={this.fileChangedHandler}
                                />
                              </div>
                              <div className="errStyle">
                                {this.state.fileError}
                              </div>
                            </div>
                          </div>
                        </Form.Group>
                      </div>
                    </Col>
                  </Row>
                  {/* <div className="profilebody"> <hr /></div> */}
                </Card.Body>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
        </Row>

        <Row>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
          <Col xs={12} sm={12} md={10} lg={10}>
            <Card>
              <div>
                <h5 className="tablecardtitle edithead">Organization Details</h5>
              </div>

              <div className="myprofilebody">
                <Card.Body>
                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="name">
                                <Form.Label>Organization Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="name"
                                  onChange={this.onChange}
                                  value={this.state.value.name}
                                />
                                <div className="errStyle">
                                  {this.state.nameError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="addr1">
                                <Form.Label>Location</Form.Label>

                                <PlacesAutocomplete
                                  value={this.state.value.addr1}
                                  onChange={this.onLocationChange}
                                  onSelect={this.handleSelect}
                                  autoComplete="off"
                                >
                                  {({
                                    getInputProps,
                                    suggestions,
                                    getSuggestionItemProps,
                                    loading
                                  }) => (
                                    <div>
                                      <input
                                        className="autocompleteInput"
                                        {...getInputProps({
                                          placeholder: "Type address"
                                        })}
                                      />

                                      <div>
                                        {loading ? <div>...loading</div> : null}

                                        {suggestions.map(suggestion => {
                                          const style = {
                                            backgroundColor: suggestion.active
                                              ? "#1768B7"
                                              : "#fff"
                                          };


                                          return (
                                            <div
                                              {...getSuggestionItemProps(
                                                suggestion,
                                                {
                                                  style
                                                }
                                              )}
                                            >
                                              {suggestion.description}
                                            </div>
                                          );
                                        })}
                                      </div>
                                    </div>
                                  )}
                                </PlacesAutocomplete>
                                <div
                                  className="errStyle" /* style={{ float: "left" }} */
                                >
                                  {/* {this.state.addr1Error} */}
                                  {this.state.locationError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="zip">
                                <Form.Label> Pin Code</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="zip"
                                  onChange={this.onChange}
                                  value={this.state.value.zip}
                                />
                                <div
                                  className="errStyle"
                                  style={{ float: "left" }}
                                >
                                  {this.state.zipError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="state">
                                <Form.Label className="mandatoryField">
                                  State
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="state"
                                  onChange={this.selectState}
                                >
                                  {this.props.statesList &&
                                    this.props.statesList.map(
                                      (item, i) =>
                                        this.state.value.state == item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                  {this.props.statesList &&
                                    this.props.statesList.map(
                                      (item, i) =>
                                        this.state.value.state !== item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                </Form.Control>
                                <div className="errStyle">
                                  {this.state.stateError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="district">
                                <Form.Label className="mandatoryField">
                                  District
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="district"
                                  onChange={this.selectDistrict}

                                >

                                  {this.props.districtById &&
                                    this.props.districtById.map(
                                      (item, i) =>
                                        this.state.value.district ===
                                        item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                  {this.props.districtById &&
                                    this.props.districtById.map(
                                      (item, i) =>
                                        this.state.value.district !==
                                        item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                </Form.Control>
                              </Form.Group>

                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>

                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="city">
                                <Form.Label> City</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="city"
                                  onChange={this.onChange}
                                  value={this.state.value.city}
                                />
                                <div className="errStyle">
                                  {this.state.cityError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="landmark">
                                <Form.Label>Landmark</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="landmark"
                                  onChange={this.onChange}
                                  value={this.state.value.landmark}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="website">
                                <Form.Label>Website</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="website"
                                  onChange={this.onChange}
                                  value={this.state.value.website}
                                />
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="licenceNo">
                                <Form.Label>Drug License(20B)</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="licenceNo"
                                  onChange={this.onChange}
                                  value={this.state.value.licenceNo}
                                />
                                <div className="errStyle">
                                  {this.state.licenceNoError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>

                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="licenceNo2">
                                <Form.Label>Drug License(21B)</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="licenceNo2"
                                  onChange={this.onChange}
                                  value={this.state.value.licenceNo2}
                                />
                                <div className="errStyle">
                                  {this.state.licenceNo2Error}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="gstin">
                                <Form.Label>GST Number </Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="gstin"
                                  onChange={this.onChange}
                                  value={this.state.value.gstin}
                                />
                                <div className="errStyle">
                                  {this.state.gstError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>

                      <Form.Group controlId="crdtPeriod">
                        <Form.Label>Credit Period</Form.Label>
                        <Form.Control
                          type="number"
                          autoComplete="off"
                          name="crdtPeriod"
                          step={10}
                          min={0}
                          placeholder="0"
                          onChange={this.onChange}
                          value={this.state.value.crdtPeriod}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}></Col>
                  </Row>
                </Card.Body>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
        </Row>

        <Row>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
          <Col xs={12} sm={12} md={10} lg={10}>
            <Card>
              <div>
                <h5 className="tablecardtitle edithead">Working Hours</h5><br />
                <div className="myprofilebody" style={{ marginLeft: "20px" }}>
                  {Object.keys(this.state.value.workingHrs).map((item, i) => (
                    <tr>
                      <td>
                        <input
                          type="checkbox"
                          checked={this.state.value.workingHrs[item].isWorking}
                          onClick={e => this.oncheckChange(e, item)}
                        />
                      </td>&nbsp;&nbsp;
                      <td>{this.state.value.workingHrs[item].showDay}</td>&nbsp;&nbsp;&nbsp;
                      <td>
                        <TimePicker
                          format="hh:mm a"
                          clockIcon={null}
                          disableClock={true}
                          clearIcon={null}
                          value={this.state.value.workingHrs[item].open}
                          onChange={e =>
                            this.ontimeChange(e, item, "open", "openmin")
                          }
                        />
                      </td>
                      <td>
                        <TimePicker
                          format="hh:mm a"
                          clockIcon={null}
                          disableClock={true}
                          clearIcon={null}
                          value={this.state.value.workingHrs[item].close}
                          onChange={e =>
                            this.ontimeChange(e, item, "close", "closemin")
                          }
                        />
                      </td>
                    </tr>
                  ))}
                </div>
              </div>
            </Card>
          </Col>
        </Row>

        <Row>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
          <Col xs={12} sm={12} md={10} lg={10}>
            <Card>
              <div>
                <h5 className="tablecardtitle edithead">Bank Details</h5>
              </div>

              <div className="myprofilebody">
                <Card.Body>
                  <Row>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="bankName">
                                <Form.Label className="mandatoryField">
                                  Select Your Bank
                                </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="bankName"
                                  onChange={this.onChange}
                                >
                                  {this.props.banks &&
                                    this.props.banks.map(
                                      (item, i) =>
                                        this.state.value.bankName ===
                                        item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                  {this.props.banks &&
                                    this.props.banks.map(
                                      (item, i) =>
                                        this.state.value.bankName !==
                                        item.id && (
                                          <option key={i} value={item.id}>
                                            {item.name}
                                          </option>
                                        )
                                    )}
                                </Form.Control>
                                <div className="errStyle">
                                  {this.state.bankNameError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>

                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="acntNo">
                                <Form.Label>Account No</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="acntNo"
                                  onChange={this.onChange}
                                  value={this.state.value.acntNo}
                                />
                                <div className="errStyle">
                                  {this.state.acntNoError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>

                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="brchAddr">
                                <Form.Label>Branch Address </Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="brchAddr"
                                  onChange={this.onChange}
                                  value={this.state.value.brchAddr}
                                />
                                {/* <div className="errStyle">
                                  {this.state.gstError}
                                </div> */}
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="acntName">
                                <Form.Label>Account Holder Name</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="acntName"
                                  onChange={this.onChange}
                                  value={this.state.value.acntName}
                                />
                                <div className="errStyle">
                                  {this.state.acntNameError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>

                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="ifscCode">
                                <Form.Label>IFSC</Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="ifscCode"
                                  onChange={this.onChange}
                                  value={this.state.value.ifscCode}
                                />
                                <div className="errStyle">
                                  {this.state.ifscCodeError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                    <Col xs={12} sm={12} md={4} lg={4}>
                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="acntType">
                                <Form.Label> Account Type </Form.Label>
                                <Form.Control
                                  as="select"
                                  name="acntType"
                                  onChange={this.onChange}
                                  value={this.state.value.acntType}
                                >
                                  <option value="">Select</option>
                                  <option value="saving">Savings</option>
                                  <option value="current">Current</option>
                                </Form.Control>
                                <div className="errStyle">
                                  {this.state.acntTypeError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>

                      <div>
                        <Form onKeyDown={this.onKeyDown}>
                          <div>
                            <div>
                              <Form.Group controlId="brchName">
                                <Form.Label>Branch Name </Form.Label>
                                <Form.Control
                                  type="text"
                                  autoComplete="off"
                                  name="brchName"
                                  onChange={this.onChange}
                                  value={this.state.value.brchName}
                                />
                                <div className="errStyle">
                                  {this.state.brchNameError}
                                </div>
                              </Form.Group>
                            </div>
                          </div>
                        </Form>
                      </div>
                    </Col>
                  </Row>

                  <Button
                    className="queryBtn"
                    onClick={this.editWorkingHrs}
                    style={{ float: "right" }}
                  >
                    Submit
                  </Button>
                </Card.Body>
              </div>
            </Card>
          </Col>
          <Col xs={12} sm={12} md={1} lg={1}></Col>
        </Row>
      </div>
    );
  }
}
// export default EditProfile;
function bindAction(dispatch) {
  return {
    fetchDistributorProfile: () => {
      dispatch(fetchDistributorProfile());
    },
    EditDistributorprof: value => {
      dispatch(EditDistributorprof(value));
    },
    fetchStates: () => {
      dispatch(fetchStates());
    },
    fetchDistrictById: value => {
      dispatch(fetchDistrictById(value));
    },
    fetchBank: () => {
      dispatch(fetchBank());
    }
  };
}

const mapStateToProps = state => ({
  DistributorprofDtls: state.MyProfileReducer.DistributorprofDtls,
  statesList: state.MyProfileReducer.statesList,
  districtById: state.MyProfileReducer.districtById,
  banks: state.MyProfileReducer.banks
});

export default connect(
  mapStateToProps,
  bindAction
)(EditProfile);
